export function indexOfSmallest(input: number[]) {
	return input.indexOf(Math.min(...input));
}
